import countries from "data/country.json";
import Maybe from "components/__new/common/Maybe";
import moment from "moment";
import { FileUploadForm, Input, SelectInput } from "components/__new/common/form";
import { identityDocumentLabel } from "data/documentLabel";
import { ReactComponent as IconTrash } from "assets/images/icons/project-icons/thrash.svg";
import ReactTooltip from "react-tooltip";
import DialogBox from "utils/dialogBox";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


const DirectorInformation = (props) => {
    const { index, director, directorType, checkFormValidation, updateDirector, directorToDelete, deleteDirector } = props;
    
    const updateForm = (name, value) => {
        const data = {
            ...director,
            [name]: value,
        }
        updateDirector(data);
    }
    
    const deleteDirectorPrompt = async (id, index) => {
        const result = await DialogBox({
			title: <>Delete {directorType?.label} 😯</>,
			content: <>Are you sure you want to delete <br /> this {directorType?.label}?</>,
			buttonYes: "Delete " + directorType?.label,
            buttonYesClass: "btn-ep-red",
			buttonNo: "Cancel",
		});
		if (result) {
            deleteDirector(id, index);
        }
    }
    
    return (
        <div className="relative">
            <Maybe condition={directorToDelete === index}>
                <div className="w-full h-full flex items-center justify-center absolute z-10 top-0 bg-white bg-opacity-80 text-gray-500 text-center">
                    <div>
                        <FontAwesomeIcon icon="spinner" spin className="text-6xl" />
                        <div className="mt-2 font-semibold uppercase text-xl">
                            Deleting {directorType?.label}
                        </div>
                    </div>
                </div>
            </Maybe>
            
            <div className="relative z-0 pt-4 pb-6 border-b mb-4">
                <div className="mb-6 flex items-center justify-between">
                    <div>
                        <div className="font-bold capitalize">
                            {directorType?.label} {index + 1}
                        </div>
                        <div className="text-sm text-ep-gray-600">
                            Please fill in the details to verify this {directorType?.label}
                        </div>
                    </div>
                    <div>
                        <Maybe condition={index > (directorType?.minimumDirectors - 1 ?? 1)}>
                            <div onClick={() => deleteDirectorPrompt(director?._id, index)} data-tip data-for="delete-director" className="w-10 h-10 rounded flex hover:bg-red-500 group cursor-pointer">
                                <IconTrash className="w-5 h-5 m-auto group-hover:svg-fill-white" />
                            </div>
                            <ReactTooltip id="delete-director" className="tooptip-size">
                                Delete {directorType?.label} {index + 1}
                            </ReactTooltip>
                        </Maybe>
                    </div>
                </div>
                
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4">
                    <Input type="text" label="First Name" required={true} value={director.directorFirstName} onChange={(e) => updateForm("directorFirstName", e.target.value)} validationName="directorFirstName" checkFormValidation={checkFormValidation} inputClass="capitalize" />
                    <Input type="text" label="Last Name" required={true} value={director.directorLastName} onChange={(e) => updateForm("directorLastName", e.target.value)} validationName="directorLastName" checkFormValidation={checkFormValidation} inputClass="capitalize" />
                    
                    {/* <Input type="date" label="Date of Birth" max={new Date().toISOString().split('T')[0]} required={true} value={director.directorDob} onChange={(e) => updateForm("directorDob", e.target.value)} validationName="directorDob" checkFormValidation={checkFormValidation} /> */}
                    <Input type="date" label="Date of Birth" max={moment().subtract(18, 'years').format("YYYY-MM-DD")} required={true} value={director.directorDob} onChange={(e) => updateForm("directorDob", e.target.value)} validationName="directorDob" checkFormValidation={checkFormValidation} />
                    
                    <SelectInput label="Nationality" required={true} value={director.nationality} onChange={(e) => updateForm("nationality", e.target.value)} validationName="nationality" checkFormValidation={checkFormValidation}>
                        <option value="">Select Country</option>
                        {countries.map(country => 
                            <option key={country.code} value={country.name.toLowerCase()}>{country.name}</option>
                        )}
                    </SelectInput>
                </div>
                
                <div className="mb-4">
                    <div className="font-bold">
                        Identity Verification
                    </div>
                    <div className="text-sm text-ep-gray-600">
                        Please upload the {directorType?.label}'s personal identification documents.
                    </div>
                </div>
                
                <SelectInput label="Document Type" required={true} value={director.documentType} onChange={(e) => updateForm("documentType", e.target.value)} validationName="documentType" checkFormValidation={checkFormValidation}>
                    <option value="">Select Type</option>
                    {Object.keys(identityDocumentLabel).map((name, index) =>
                        <option key={index} value={name}>{identityDocumentLabel[name]}</option>
                    )}
                </SelectInput>
                            
                <Maybe condition={director.documentType !== ""}>
                    <FileUploadForm
                        data={director.documentFile}
                        onchange={(e) => updateForm("documentFile", e)}
                        filetype={["jpg","jpeg","png","pdf"]}
                        filename="Identity verification document"
                        validationName="documentFile"
                        checkFormValidation={checkFormValidation}
                    />
                </Maybe>
                
                <Input type="number" label="BVN" required={true} value={director.bvn} onChange={(e) => updateForm("bvn", e.target.value)} validationName="bvn" checkFormValidation={checkFormValidation} />
            </div>
        </div>
    )
}

export default DirectorInformation;